import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {MessageInterface} from '../models/chat';
import {environment} from '../environments/enviroment';


@Injectable({
  providedIn: 'root'
})
export class CustomerMessageService {

  private domain: string = `${environment.mindxbkUrl}CustomerMessage/Message/`;

  constructor(private http: HttpClient) {}

  getMessagesByConversationId(conversationId: string): Observable<MessageInterface[]> {
    const token = localStorage.getItem('auth_req');
    if (!token) {
      console.error('❌ No se encontró token en localStorage (auth_req)');
      return throwError(() => new Error('No auth token available'));
    }

    const url = `${this.domain}${conversationId}`;
    const headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    });

    return this.http.get<MessageInterface[]>(url, {headers});
  }
}
